<template>
  <v-list>
    <MeasurementOptions
      :deviceIds="deviceIds"
      :passedinParameter="passedinParameter"
      :widgetId="widgetId"
      @parameterChange="parameterChange"
    />
    <v-divider></v-divider>
    <!-- Show Data Gap Line -->
    <v-list-item>
      <v-switch
        v-model="showDataGapLine"
        color="primary"
        :label="$t('map.historyDialog.dropdown.showDataGapLine')"
        density="compact"
        class="dataGapLineToggle"
        hide-details
      ></v-switch>
    </v-list-item>
    <!-- Export Data -->
    <v-list-item @click.stop="$emit('openExportData')" data-cy="exportData">
      <template v-slot:prepend>
        <v-icon icon="mdi-file-download" />
      </template>
      <v-list-item-title>{{ $t('map.historyDialog.dropdown.exportCsv') }}</v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { NAMESPACES } from '@/store/types'
import { USER_GETTERS, USER_ACTIONS } from '@/store/user'
import type { WidgetDevice } from '@/helpers/widgets/helper'
import MeasurementOptions from '@/components/devicePopover/content/dropdown/MeasurementOptions.vue'
import { addUserSetting } from '@/services/user-settings'

export default defineComponent({
  name: 'history-menu',
  components: {
    MeasurementOptions
  },
  props: {
    selectedDevices: { type: Array as PropType<WidgetDevice[]>, required: true },
    passedinParameter: Number,
    widgetId: String,
    permissions: { type: Object as PropType<Record<string, string[]>>, required: true }
  },
  emits: ['parameterChange', 'openExportData'],
  data() {
    return {
      showDataGapLine: this.$store.getters[
        `${NAMESPACES.USER}/${USER_GETTERS.GET_SHOW_DATA_GAP_LINE}`
      ] as boolean
    }
  },
  watch: {
    showDataGapLine(showDataGapLine: boolean) {
      this.updateShowDataGapLine(showDataGapLine)
    }
  },
  computed: {
    deviceId() {
      return this.selectedDevices?.[0]?.id || ''
    },
    deviceIds(): string[] {
      return this.selectedDevices.map((device) => {
        return device.id
      })
    }
  },
  methods: {
    parameterChange(newValue: number) {
      this.$emit('parameterChange', newValue)
    },
    async updateShowDataGapLine(showDataGapLine: boolean) {
      const setting = addUserSetting({ showDataGapLine })
      try {
        // update api
        await this.$api.patchUserSettings(setting)
        // update store
        this.$store.dispatch(`${NAMESPACES.USER}/${USER_ACTIONS.UPDATE_SETTINGS}`, setting)
      } catch {
        // don't change the previous selection
        // eslint-disable-next-line no-console
        console.error('Unable to patch user settings for showDataGapLine')
      }
    }
  }
})
</script>
<style lang="scss" scoped>
.v-list {
  padding: 0px;
  :deep(.v-list-item__content) {
    overflow: visible;
  }
}

.v-input--switch {
  padding-top: 0;
  margin-top: 0;
}

.dataGapLineToggle {
  padding-left: 8px;
}
</style>
